import { useRef, useEffect } from 'react';

/**
 * {@see https://overreacted.io/making-setinterval-declarative-with-react-hooks/}
 */
var useInterval = function useInterval(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var runAtFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var savedCallback = useRef();
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    function tick() {
      if (typeof savedCallback.current === 'function') {
        savedCallback.current();
      }
    }
    if (runAtFirst) {
      tick();
    }
    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay, runAtFirst]);
};

export { useInterval as default };
